import {Component, Prop, Vue} from "vue-property-decorator";
import {Icon, icons} from "~/components/icon";
import {sort} from "~/lib/helpers";
import {getUsersManagementStore} from "~/modules/users/store";

const MAX_VISIBLE_ROLES = 3;

const usersManagementStore = getUsersManagementStore();

@Component
export class UsersRolesSummary extends Vue {

  @usersManagementStore.State rolesConfig;
  @usersManagementStore.State users;

  countUsersForRole(roleConfig){
    return roleConfig.meta.usersCount;
  }

  // sorted by users count
  get list(){
    return sort(this.rolesConfig, (a, b) => {
      let aCount = this.countUsersForRole(a);
      let bCount = this.countUsersForRole(b);
      if( aCount < bCount) return 1;
      if( aCount > bCount) return -1;
      return 0;
    }).slice(0, MAX_VISIBLE_ROLES);
  }

  render() {
    return (
      <div class="roles-summary">
        {this.list.map((config:any) => <RoleComponent
          role={config.role}
          count={this.countUsersForRole(config)}
        />)}
        <p class="roles-summary_see-all" onClick={() => this.$emit("showAllRoles")}>Voir tous les rôles</p>
        <ScopesViewerLink />
      </div>
    );
  }
}

@Component
class RoleComponent  extends Vue {

  @Prop({type:Object, required:true}) role:any;
  @Prop({type:Number, required:true}) count:number;

  render(){
    return (
      <div class="roles-summary_role">
        <span class="count">{this.count}</span>
        <span class="label">{this.role.label}</span>
      </div>
    );
  }

}

@Component
class ScopesViewerLink extends Vue {
  render(){
    return (
      <div class="scopes-viewer-link" onClick={() => this.$bubble("showScopes")}>
        <Icon icon={icons.multiSettings} />
        <span>Voir les droits par rôle</span>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1fd72d5a/roles-summary.tsx" });